export const key2value = (data, keyName = 'value', valueName = 'label') => {
  const obj = {};
  data.forEach((item) => {
    obj[item[keyName]] = item[valueName];
  });
  return obj;
};

// 目标状态
export const TARGET_STATUS_OA = [
  { label: '未设定', value: 'TARGET_STATUS_UNSET' },
  { label: '未达标', value: 'TARGET_STATUS_NON_CONFORMANCE' },
  { label: '已达标', value: 'TARGET_STATUS_CONFORMANCE' },
];
export const TARGET_STATUS_OA_KEY2VALYE = key2value(TARGET_STATUS_OA);

// 目标状态
export const TARGET_STATUS = [
  // { label: '未设定', value: 1 },
  // { label: '待执行', value: 2 },
  { label: '未达标', value: 'TARGET_STATUS_NON_CONFORMANCE' },
  { label: '已达标', value: 'TARGET_STATUS_CONFORMANCE' },
];
export const TARGET_STATUS_KEY2VALYE = key2value(TARGET_STATUS);

// 订单进展
export const ORDER_STATUS = [
  { label: '未知', value: 'TARGET_PROGRESS_UNKNOWN' },
  { label: '未完成-提前', value: 'TARGET_PROGRESS_UNFINISHED_ADVANCE' },
  { label: '未完成-正常', value: 'TARGET_PROGRESS_UNFINISHED_NORMAL' },
  { label: '未完成-落后', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD' },
  { label: '未完成-落后20%以上', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20' },
  { label: '完成-提前', value: 'TARGET_PROGRESS_FINISHED_ADVANCE' },
  { label: '完成-正常', value: 'TARGET_PROGRESS_FINISHED_NORMAL' },
];
export const ORDER_STATUS_KEY2VALYE = key2value(ORDER_STATUS);

// 到款进展 广告费进展
export const PAY_STATUS = [
  { label: '未知', value: 'TARGET_PROGRESS_UNKNOWN' },
  { label: '未完成-提前', value: 'TARGET_PROGRESS_UNFINISHED_ADVANCE' },
  { label: '未完成-正常', value: 'TARGET_PROGRESS_UNFINISHED_NORMAL' },
  { label: '未完成-落后', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD' },
  { label: '未完成-落后20%以上', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20' },
  { label: '完成-提前', value: 'TARGET_PROGRESS_FINISHED_ADVANCE' },
  { label: '完成-正常', value: 'TARGET_PROGRESS_FINISHED_NORMAL' },
];
export const PAY_STATUS_KEY2VALYE = key2value(PAY_STATUS);

export const STATUS_NUM2KEY = {
  0: 'TARGET_PROGRESS_UNKNOWN',
  1: 'TARGET_PROGRESS_UNFINISHED_ADVANCE',
  2: 'TARGET_PROGRESS_UNFINISHED_NORMAL',
  3: 'TARGET_PROGRESS_UNFINISHED_BACKWARD',
  4: 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20',
  5: 'TARGET_PROGRESS_FINISHED_ADVANCE',
  6: 'TARGET_PROGRESS_FINISHED_NORMAL',
};

// 电话量进展
export const PHONE_STATUS = [
  { label: '未知', value: 'TARGET_PROGRESS_UNKNOWN' },
  { label: '未完成-提前', value: 'TARGET_PROGRESS_UNFINISHED_ADVANCE' },
  { label: '未完成-正常', value: 'TARGET_PROGRESS_UNFINISHED_NORMAL' },
  { label: '未完成-落后', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD' },
  { label: '未完成-落后20%以上', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20' },
  { label: '完成-提前', value: 'TARGET_PROGRESS_FINISHED_ADVANCE' },
  { label: '完成-正常', value: 'TARGET_PROGRESS_FINISHED_NORMAL' },
];
export const PHONE_STATUS_KEY2VALYE = key2value(PHONE_STATUS);

// 通话时长进展
export const PHONE_TIME_STATUS = [
  { label: '未知', value: 'TARGET_PROGRESS_UNKNOWN' },
  { label: '未完成-提前', value: 'TARGET_PROGRESS_UNFINISHED_ADVANCE' },
  { label: '未完成-正常', value: 'TARGET_PROGRESS_UNFINISHED_NORMAL' },
  { label: '未完成-落后', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD' },
  { label: '未完成-落后20%以上', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20' },
  { label: '完成-提前', value: 'TARGET_PROGRESS_FINISHED_ADVANCE' },
  { label: '完成-正常', value: 'TARGET_PROGRESS_FINISHED_NORMAL' },
];
export const PHONE_TIME_STATUS_KEY2VALYE = key2value(PHONE_TIME_STATUS);

// 新增线索数
export const CLEW_STATUS = [
  { label: '未知', value: 'TARGET_PROGRESS_UNKNOWN' },
  { label: '未完成-提前', value: 'TARGET_PROGRESS_UNFINISHED_ADVANCE' },
  { label: '未完成-正常', value: 'TARGET_PROGRESS_UNFINISHED_NORMAL' },
  { label: '未完成-落后', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD' },
  { label: '未完成-落后20%以上', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20' },
  { label: '完成-提前', value: 'TARGET_PROGRESS_FINISHED_ADVANCE' },
  { label: '完成-正常', value: 'TARGET_PROGRESS_FINISHED_NORMAL' },
];
export const CLEW_STATUS_KEY2VALYE = key2value(CLEW_STATUS);

// 新增商机数
export const POTENTIALS_STATUS = [
  { label: '未知', value: 'TARGET_PROGRESS_UNKNOWN' },
  { label: '未完成-提前', value: 'TARGET_PROGRESS_UNFINISHED_ADVANCE' },
  { label: '未完成-正常', value: 'TARGET_PROGRESS_UNFINISHED_NORMAL' },
  { label: '未完成-落后', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD' },
  { label: '未完成-落后20%以上', value: 'TARGET_PROGRESS_UNFINISHED_BACKWARD_GT_20' },
  { label: '完成-提前', value: 'TARGET_PROGRESS_FINISHED_ADVANCE' },
  { label: '完成-正常', value: 'TARGET_PROGRESS_FINISHED_NORMAL' },
];
export const POTENTIALS_STATUS_KEY2VALYE = key2value(POTENTIALS_STATUS);

export const formatePhoneTime = (time) => {
  const fen = Math.floor((time || 0) / 60);
  const miao = (time || 0) % 60;
  return `${fen}分${miao}秒`;
};

export const IS_NEWCUSTOM = [
  { label: '是', value: 1 },
  { label: '否', value: 0 },
];
export const IS_NEWCUSTOM_KEY2VALYE = key2value(IS_NEWCUSTOM);

export const NEWCUSTOM_TYPE = [
  { label: 'D1 当季 搜狗+常规+附近推', value: 'D1 当季 搜狗+常规+附近推' },
  { label: 'D2 当季 搜狗+常规', value: 'D2 当季 搜狗+常规' },
  { label: 'D3 当季 搜狗+附近推', value: 'D3 当季 搜狗+附近推' },
  { label: 'D4 当季 常规+附近推', value: 'D4 当季 常规+附近推' },
  { label: 'D5 当季 搜狗', value: 'D5 当季 搜狗' },
  { label: 'D6 当季 常规', value: 'D6 当季 常规' },
  { label: 'D7 当季 附近推', value: 'D7 当季 附近推' },
  { label: 'DL 下季度延续未上线', value: 'DL 下季度延续未上线' },
  { label: 'D0 当季 政策新客', value: 'D0 当季 政策新客' },
  { label: 'Y1 延续 搜狗+常规+附近推', value: 'Y1 延续 搜狗+常规+附近推' },
  { label: 'Y2 延续 搜狗+常规', value: 'Y2 延续 搜狗+常规' },
  { label: 'Y3 延续 搜狗+附近推', value: 'Y3 延续 搜狗+附近推' },
  { label: 'Y4 延续 常规+附近推', value: 'Y4 延续 常规+附近推' },
  { label: 'Y5 延续 搜狗', value: 'Y5 延续 搜狗' },
  { label: 'Y6 延续 常规', value: 'Y6 延续 常规' },
  { label: 'Y7 延续 附近推', value: 'Y7 延续 附近推' },
  { label: 'Y0 延续 政策新客', value: 'Y0 延续 政策新客' },
  { label: '0 非政策新客', value: '0 非政策新客' },
];
export const NEWCUSTOM_TYPE_KEY2VALYE = key2value(NEWCUSTOM_TYPE);
